import { useTranslation } from 'react-i18next'

import { maxPassengerCount, minPassengerCount } from 'entities/umrah/types'

import { ButtonInputValue } from 'shared/ui/button-input-value'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  onChange: (value: number) => void
  passengers: number
}

export const PrepaymentPassengers = ({ onChange, passengers }: Props) => {
  const { t } = useTranslation()

  return (
    <Paper padding={[12, 16, 12, 16]}>
      <ButtonInputValue
        value={passengers}
        minNumber={minPassengerCount}
        maxNumber={maxPassengerCount}
        title={t('umrah_block.pilgrims_count_text')}
        subTitle={t('umrah_block.from_to', {
          from: minPassengerCount,
          to: maxPassengerCount,
        })}
        titleClass={s.titleFont}
        onChange={(value) => onChange(value)}
      />
    </Paper>
  )
}
